module.exports = __webpack_public_path__ + "img/sign-top.073509fb.png";